import { defaultPostLoginPath } from '@/auth/principal'
import { Navigate } from 'react-router-dom'

/** App index / catch-all: send authenticated users to the group dashboard shell. */
export function DefaultAuthenticatedRedirect() {
  return <Navigate to={defaultPostLoginPath()} replace />
}
